import { InteractionItem } from '../InteractionItem';
import { InspectionItem } from '../InspectionItem';

export default (inspectionItem: InspectionItem | InteractionItem): inspectionItem is InspectionItem =>
    !Object.hasOwnProperty.call(inspectionItem, 'occupantId');
